export default __webpack_public_path__ + "static/media/food3.670a9ee6.jpeg";